import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {IMyDpOptions, IMyDate} from 'mydatepicker';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';
import { holidays } from '../../../../../assets/holidays';

@Component({
  selector: 'app-cq11',
  templateUrl: './cq11.component.html',
  styleUrls: ['./cq11.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq11Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  questionObj;
  deviceWidth;
  date;
  public model: any;
  disableDays: Array<IMyDate> = [];
  disableAfter: IMyDate;
  public myDatePickerOptions: IMyDpOptions;
  timer;
  isChecked = false;
  switch_by;
  elem1;
  ans_switch_date;
  switchDate;
  location_switchDates = [];
  hgHolidays: Array<any>;
  showTyping = false;
  time = 3000;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.hgHolidays = holidays.hgHolidays;
    for ( let i = 0; i < this.hgHolidays.length; i++) {
      this.disableDays.push({ year: this.hgHolidays[i].year, month: this.hgHolidays[i].month, day: this.hgHolidays[i].day});
    }
    const dt = new Date().setDate(new Date().getDate() + 60 );
    this.disableAfter = { year: new Date(dt).getFullYear(), month: new Date(dt).getMonth() + 1, day: new Date(dt).getDate()};
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek:"su",
      // disableSince : this.disableAfter,
      disableDays: this.disableDays,
      disableWeekends: true,
      disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
      editableDateField : false,
      showClearDateBtn: false,
      selectorHeight: '100%',
      selectorWidth: '100%',
      openSelectorOnInputClick : true,
      openSelectorTopOfInput : false
    };
  
    if(this.deviceWidth < 768)
    {
      this.myDatePickerOptions.openSelectorTopOfInput = true;
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('switch_mob');
    } else {
      this.elem1 = document.getElementById('switch');
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.location_switchDates = obj.fieldValue;
        if (!this.commercialService.addAddress && !_.isEmpty(this.location_switchDates)) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = this.location_switchDates.length - 1;
          }
          if (!_.isEmpty(this.location_switchDates[index])) {
            this.switch_by = this.location_switchDates[index].value;
            if (this.switch_by.value === 'Switch by') {
              this.isChecked = true;
              // this.elem1.parentElement.classList.add('active-select');
              if (typeof (this.switch_by.date) === 'string') {
                this.date = JSON.parse(this.switch_by.date);
              } else {
                this.date = this.switch_by.date;
              }
              if (this.date) {
                if (typeof (this.date) === 'string') {
                  this.date = new Date(this.date);
                }
                this.model = { date: { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() } };
                this.switchDate = this.pad(this.model.date.month) + '/' + this.model.date.day + '/' + this.model.date.year;
                this.ans_switch_date = this.switch_by.value + ' ' + this.switchDate;
                this.user_bot = true;
                if (this.deviceWidth < 768) {
                  if (this.commercialService.modifyAddress) {
                    this.typingNext();
                  } else {
                    this.goNext();
                  }
                }
              }
            }
          }
        }
      }
    }

    if(_.isEmpty(this.model))
    {
      this.showbutton = false;
    }
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  getSwitchDate() {
    if (this.isChecked) {
      this.elem1.parentElement.classList.add('active-select');
      if (this.date === undefined || this.date === null) {
        this.switch_by = { 'value': 'Switch by', 'date': '' };
      } else {
        this.switch_by = { 'value': 'Switch by', 'date': this.date };
      }
      if (_.isEmpty(this.model)) {
        this.user_bot = false;
      } else {
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.switch_by = '';
      this.user_bot = false;
      this.elem1.parentElement.classList.remove('active-select');
    }
  }

  getDate() {
    if (!this.isChecked) {
      this.isChecked = true;
    }
    // this.elem1.parentElement.classList.add('active-select');
    this.date = new Date(this.model.formatted);
    this.switchDate = this.pad(this.model.date.month) + '/' + this.model.date.day + '/' + this.model.date.year;
    this.switch_by = { 'value': 'Switch by', date: JSON.stringify(this.date) };
    this.ans_switch_date = this.switch_by.value + ' ' + this.switchDate;
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }

    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  save() {
    let index;
    if (this.commercialService.serialNumber !== null) {
      index = this.commercialService.serialNumber;
    } else if (this.commercialService.serialNumber === null) {
      index = this.location_switchDates.length;
    }
    this.location_switchDates[index] = { 'serialNo': index + 1, 'value': this.switch_by };
    const Obj = {
      'com_question_id': this.data,
      'fieldName': 'switch_by',
      'fieldValue': this.location_switchDates
    };
    this.commercialService.updateResponses(Obj);
  }

  next() {
    if (_.isEmpty(this.switch_by)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      if (_.isEmpty(this.model)) {
      } else {
        this.ans_switch_date = this.switch_by.value + ' ' + this.switchDate;
        this.save();
        this.commercialService.messageService({ 'currentId': this.data });
      }
    }
  }

}
